import { useNavigate } from "react-router-dom"
import { FaArrowRight, FaHome, FaNewspaper } from "react-icons/fa"
import "./Articles.css"

function Articles() {
  const navigate = useNavigate()

  const articles = [
    {
      title: "Prameela Foundation distributes educational materials to students",
      category: "News",
      date: "2025-02-15",
      excerpt:
        "Coverage by NTNews on Pramila Foundation distributing educational materials to students in Mahabubnagar.",
      link: "https://www.ntnews.com/mahabubnagar/prameela-foundation-distributes-educational-materials-to-students-2037811",
    }
  ]

  return (
    <section className="articles-page">
      <div className="container">
        <div className="section-header">
          <p className="articles-tagline">Latest From Pramila Foundation</p>
          <h2>News Articles</h2>
          <div className="underline"></div>
          <p className="articles-intro">
            Explore featured coverage, updates, and stories connected to our programs and public impact.
          </p>
        </div>

        <div className="articles-grid">
          {articles.map((article) => (
            <article className="article-card" key={article.title}>
              <div className="article-card-top">
                <span className="article-category">{article.category}</span>
                <FaNewspaper className="article-icon" />
              </div>
              <h3>{article.title}</h3>
              <p className="article-date">{new Date(article.date).toLocaleDateString()}</p>
              <p className="article-excerpt">{article.excerpt}</p>
              <button type="button" className="article-link" onClick={() => window.open(article.link, '_blank')}>
                Read More <FaArrowRight />
              </button>
            </article>
          ))}
        </div>

        <div className="home-button-container">
          <button className="home-button" onClick={() => navigate("/")}>
            <FaHome className="button-icon" /> Back to Home
          </button>
        </div>
      </div>
    </section>
  )
}

export default Articles
